
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const TentangKami = lazy(() => import('../pages/tentang-kami/page'));
const Layanan = lazy(() => import('../pages/layanan/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/tentang-kami',
    element: <TentangKami />,
  },
  {
    path: '/layanan',
    element: <Layanan />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
